import css from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/lifMonitoring.module.css'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import LiftAccelerationChart from '@/pages/Equipment/pages/LiftPage/pages/LiftAnalysis/LiftAccelerationChart'
import Tabs from '@/shared/Tabs'
import useAnalyticsPresetsCtrl from '@/pages/Equipment/pages/LiftPage/pages/LiftAnalysis/LiftAnalysisContent/useAnalyticsPresetsCtrl.tsx'
import useEquipment from '@/pages/Equipment/hooks/useEquipment.ts'

interface IProps {
  isLive: boolean
  equipmentId: IEquipment['id']
  selectedDate: Date
}

const LiftAnalysisContent = (props: IProps) => {
  const equipment = useEquipment(props.equipmentId)
  const presetsCtrl = useAnalyticsPresetsCtrl(equipment?.protocolId)

  return (
    <div className="mt16" style={{ flex: 1 }}>
      <div className={css.mainCard} style={{ height: '100%' }}>
        <Tabs
          tabs={presetsCtrl.data.tabs}
          onSelect={presetsCtrl.handlers.handleSelectPreset}
          selectedTab={presetsCtrl.data.selectedPreset.id}
          withCreate={true}
          onCreate={presetsCtrl.handlers.handlePresetCreate}
          style={{ gap: '20px' }}
          tabStyle={{ paddingLeft: '4px', paddingRight: '4px' }}
        />

        <LiftAccelerationChart
          isLive={props.isLive}
          startTime={props.selectedDate?.getTime()}
          equipmentId={props.equipmentId}
          parametersConfig={presetsCtrl.data.selectedPresetParametersConfig}
          onParameterAdd={
            presetsCtrl.data.selectedPreset.isLocked ? null : presetsCtrl.handlers.handleSelectedPresetAddParameter
          }
          onParameterRemove={
            presetsCtrl.data.selectedPreset.isLocked ? null : presetsCtrl.handlers.handleSelectedPresetRemoveParameter
          }
        />
      </div>
    </div>
  )
}

export default LiftAnalysisContent
